import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixComplementInfoProps } from "../types";

/**
 * Seção de contexto exibida quando a aba ativa é um Pix complementar
 * (SP-1294 / D7). Mostra que se trata de um Pix complementar e o motivo.
 * Quando o motivo não está disponível, usa um texto genérico (fallback).
 */
const PixComplementInfo: React.FC<PixComplementInfoProps> = ({ reason }) => {
  const classes = usePixModalStyles();

  return (
    <div className={classes.complementBox}>
      <p className={classes.complementTitle}>Pix complementar</p>
      <p className={classes.complementReason}>
        {reason ?? "Referente ao ajuste de valor do pedido"}
      </p>
    </div>
  );
};

export default PixComplementInfo;
